"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Pint = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M8 21h8a1 1 0 00.983-.816l1.8-9.6a9.331 9.331 0 00-.218-4.72l-.603-2.136A1 1 0 0017 3H7a1 1 0 00-.96.72l-.62 2.13a9.455 9.455 0 00-.208 4.727l1.805 9.608A1 1 0 008 21zm.83-2l-1.657-8.815a7.495 7.495 0 01.163-3.761L7.75 5h8.493l.405 1.432a7.389 7.389 0 01.174 3.758L15.17 19z" })));
exports.default = Pint;
//# sourceMappingURL=index.js.map